import { useEffect } from "react"
import { Documentation } from "./Documentation"
import { LoadingSection } from "commonsComponents/loadingSection"

export const DocumentationViewer = ({
    precontractualAlias,
    documentList: initialDocumentList,
    precontractualHasBeenInit,
    isLoadingDocumentList,
    isLoadingDocuments,
    getPreContractualDocumentationList,
    preContractualPollingInitialization,
    onSavedocumentAcceptance,
    aDocumentWasAccepted,
    aDocumentWasNotAccepted,
    precontractualLabel,
    precontractualDocumentId,
    precontractualDocumentUrl,
    precontractualDicUrl,
    onAcceptAllDocument
}) => {
    useEffect(() => {
        if (initialDocumentList.size === 0) {
            getPreContractualDocumentationList(precontractualAlias)
        }
    }, [initialDocumentList])

    const handleGetDocuments = (callback) => {
        if (!precontractualHasBeenInit) {
            preContractualPollingInitialization(precontractualAlias, precontractualDocumentId, precontractualDocumentUrl, callback, {
                precontractualDicUrl,
            });
            return
        }

        callback && callback()
    }

    if (initialDocumentList.size === 0 && isLoadingDocumentList) {
        return (
            <LoadingSection />
        )
    }

    const handleSabeDocumentAcceptance = ({ dmsDocumentId, documentChecksum, dmsDocumentType }) => {
        onSavedocumentAcceptance({ documentId: dmsDocumentId, documentChecksum, documentType: dmsDocumentType, productId: precontractualAlias })
    }

    return (
        <Documentation
            initialDocumentsList={initialDocumentList}
            getDocuments={handleGetDocuments}
            docReady={precontractualHasBeenInit}
            isLoading={isLoadingDocuments}
            onSaveDocumentAcceptance={handleSabeDocumentAcceptance}
            aDocumentWasAccepted={aDocumentWasAccepted}
            aDocumentWasNotAccepted={aDocumentWasNotAccepted}
            precontractualLabel={precontractualLabel}
            onAcceptAllDocument={onAcceptAllDocument}
        />
    )
}
